import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthService } from './auth.service';
import { EndpointBase } from './endpoint-base.service';
import { ConfigurationService } from './configuration.service';
import { Tableau } from '../models/tableau.model';
import { NewEquivalence } from '../models/new-equivalence.model';


@Injectable()
export class TableauxEndpoint extends EndpointBase {

  constructor(private configurations: ConfigurationService, http: HttpClient, authService: AuthService) {
    super(http, authService);
  }

  tableauExistEndpoint<T>(fromProgrammeId: number, toProgrammeId: number): any {
    const endpointUrl = `${this.configurations.baseUrl}/api/tableau/exist/fromProgramme/${fromProgrammeId}/toProgramme/${toProgrammeId}`;

    return this.http.get<T>(endpointUrl, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.tableauExistEndpoint(fromProgrammeId, toProgrammeId));
      }));
  }

  getTableauEndpoint<T>(fromProgrammeId: number, toProgrammeId: number): Observable<T> {
    const endpointUrl = `${this.configurations.baseUrl}/api/tableau/fromProgramme/${fromProgrammeId}/toProgramme/${toProgrammeId}`;

    return this.http.get<T>(endpointUrl, this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getTableauEndpoint(fromProgrammeId, toProgrammeId));
      }));
  }

  createTableauEndpoint<T>(tableau: Tableau): Observable<T> {
    const endpointUrl = `${this.configurations.baseUrl}/api/tableau`;

    return this.http.post<T>(endpointUrl, JSON.stringify(tableau), this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.createTableauEndpoint(tableau));
      }));
  }

  updateTableauEndpoint<T>(id: number, tab: Tableau): Observable<T> {
    const endpointUrl = `${this.configurations.baseUrl}/api/tableau/update/${tab.tableauId}`;

    return this.http.put<T>(endpointUrl, JSON.stringify(tab), this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.updateTableauEndpoint(id, tab));
      }));
  }

  createEquivalenceEndpoint<T>(newEq: NewEquivalence): Observable<T> {
    const endpointUrl = `${this.configurations.baseUrl}/api/tableau/equivalence`;

    return this.http.post<T>(endpointUrl, JSON.stringify(newEq), this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.createEquivalenceEndpoint(newEq));
      }));
  }

  changeEquivalenceEndpoint<T>(parametres: string): Observable<T> {
    const endpointUrl = `${this.configurations.baseUrl}/api/tableau/equivalencechanged`;

    return this.http.post<T>(endpointUrl, JSON.stringify(parametres), this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.changeEquivalenceEndpoint(parametres));
      }));
  }

  deleteTableauEndpoint<T>(parametres: Tableau): Observable<T> {
    const endpointUrl = `${this.configurations.baseUrl}/api/tableau/delete`;
    return this.http.post<T>(endpointUrl, JSON.stringify(parametres), this.requestHeaders).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.deleteTableauEndpoint(parametres));
      }));
  }

}
